<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>
<script>
  import { findComponentsDownward } from '../../utils/assist'
  import Emitter from '../../mixins/emitter'
  const prefixCls = 'checkbox-group'
  export default {
    name: 'TCheckboxGroup',
    mixins: [ Emitter ],
    props: {
      value: {
        type: Array,
        default () {
          return []
        }
      },
      size: {
        type: String,
        default: '',
        validator (value) {
          return [ 'sm', 'lg', '' ].includes(value)
        }
      },
      type: {
        type: String,
        default: '',
        validator (value) {
          return [ 'button', '' ].includes(value)
        }
      },
      vertical: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        currentValue: this.value,
        childrens: []
      }
    },
    computed: {
      classes () {
        return [
          `${prefixCls}`,
          {
            [`${prefixCls}--${this.size}`]: !!this.size,
            [`${prefixCls}-inline`]: !this.vertical,
            [`${prefixCls}-${this.type}`]: !!this.type
          }
        ]
      }
    },
    mounted () {
      this._updateModel(true)
    },
    methods: {
      _updateModel (update) {
        const value = this.value
        this.childrens = findComponentsDownward(this, 'TCheckbox')
        if (this.childrens) {
          this.childrens.forEach(child => {
            child.model = value
            if (update) {
              child.currentValue = value.indexOf(child.label) >= 0
              child.group = true
            }
          })
        }
      },
      _change (data) {
        this.currentValue = data
        this.$emit('input', data)
        this.$emit('on-change', data)
        this.dispatch('TFormItem', 'on-form-change', data)
      }
    },
    watch: {
      value () {
        this._updateModel(true)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// checkbox-group.vue?d78422b4